/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line import/no-internal-modules
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { useServerErrorToFormError } from './useServerErrorToFormError';
export const useEnhancedForm = ({ context, initialValues, mode = 'onBlur', schema, serverError }) => {
    const methods = useForm({
        context,
        // This allows us to support nulls as well as undefined, which we need for dates
        defaultValues: initialValues,
        mode,
        resolver: schema ? zodResolver(schema) : undefined,
    });
    useServerErrorToFormError({ serverError, setError: methods.setError });
    return methods;
};
